import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from 'antd';
import React, { useEffect, useState } from 'react';
import IntlMessage from '../../components/IntlMessage';
import _, { debounce } from 'lodash';
import useTime from '../../hooks/useTime';
import dayjs from 'dayjs';
import Status from '../../components/Status';
import {
  OrderStatus,
  PayStatus,
  dataDateType,
  dataSearchType,
  pay_method,
} from '../../utils/constant';
import { capitalizeFirstLetter, formatCurrency } from '../../helpers/helpers';
import ModalInfoBooking from './ModalInfoBooking';
import { useIntl } from 'react-intl';
import busOrdersApi from '../../api/bus_orders';
import reportApi from '../../api/report';

const { Text } = Typography;
const { Search } = Input;

const Orders = () => {
  const [form_filter] = Form.useForm();
  const [items, setItems] = useState([]);
  const [item, setItem] = useState({});
  const [loading, setLoading] = useState(false);
  const { convertToAnyTimezone, formatAsISOString } = useTime();
  const [filter, setFilter] = useState({
    limit: 50,
    page: 1,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
    // date_mode: 'date',
    filter_name: ['date_type'],
    filter_value: ['booking'],
  });
  const [condition, setCondition] = useState({});
  const [total, setTotal] = useState(null);
  const [reload, setReload] = useState(false);
  const [search, setSearch] = useState(false);
  const [mode, setMode] = useState('date');
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [isModeTravel, setIsModeTravel] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    setIsModeTravel(_.includes(filter.filter_value, 'travel'));
  }, [filter]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        await busOrdersApi.getAll(filter).then((res) => {
          setItems(res.data);
          setTotal(res?.total);
          setLoading(false);
        });
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    }

    fetchData();
  }, [search, reload, filter]);

  const [cashier, setCashier] = useState([]);
  const [filterCashier, setFilterCashier] = useState({
    page: 1,
    limit: 40,
    order_by: 'firstname',
    order_dir: 'ASC',
  });
  useEffect(() => {
    async function fetchData() {
      const res = await reportApi.getCashierReportCustomers(filterCashier);
      if (res) {
        setCashier(
          res?.map((item) => {
            return {
              value: item?.userOperator?.user?.id,
              label:
                item?.userOperator?.user?.firstname +
                ' ' +
                item?.userOperator?.user?.lastname,
            };
          })
        );
      } else {
        setCashier([]);
      }
    }

    fetchData();
  }, [filterCashier]);

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onReload = () => {
    setReload((e) => !e);
  };

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const onSearchDate = () => {
    form_filter.validateFields().then((values) => {
      const { mode, from_date, to_date, from_created_at, to_created_at } =
        values;
      const isDateMode = mode === 'date';
      const fiterUpdate = (from, to, fromDate, toDate) => ({
        [from]: isDateMode
          ? JSON.stringify(formatAsISOString(fromDate))
          : JSON.stringify(formatAsISOString(fromDate?.startOf(mode))),
        [to]: isDateMode
          ? JSON.stringify(formatAsISOString(toDate))
          : JSON.stringify(formatAsISOString(fromDate?.endOf(mode))),
      });
      if (
        (isDateMode &&
          ((from_date && to_date) || (from_created_at && to_created_at))) ||
        (!isDateMode && (from_date || from_created_at))
      ) {
        setFilter((filter) => {
          if (isModeTravel) {
            delete filter?.from_created_at;
            delete filter?.to_created_at;
            return {
              ...filter,
              ...fiterUpdate(
                'from_date',
                'to_date',
                values.from_date,
                values.to_date
              ),
            };
          } else {
            delete filter.from_date;
            delete filter.to_date;
            return {
              ...filter,
              ...fiterUpdate(
                'from_created_at',
                'to_created_at',
                values.from_created_at,
                values.to_created_at
              ),
            };
          }
        });
      } else {
        setFilter((filter) => {
          delete filter?.from_date;
          delete filter?.to_date;
          delete filter?.from_created_at;
          delete filter?.to_created_at;
          return filter;
        });
      }
      setSearch((e) => !e);
    });
  };

  const onChangeMode = (value) => {
    setMode(value);
    setFilter((item) => {
      return {
        ...item,
        date_mode: value,
      };
    });
    form_filter.setFieldsValue({
      from_date: value === 'date' ? dayjs().startOf('M') : dayjs(),
      to_date: value === 'date' ? dayjs().endOf('M') : dayjs(),
    });
  };

  const onOpenModalInfo = (record) => {
    setItem(record);
    setOpenModalInfo(true);
  };

  const onCloseModalInfo = () => {
    setOpenModalInfo(false);
  };

  const columns = [
    {
      key: 'order_number',
      fixed: true,
      dataIndex: 'order_number',
      title: <IntlMessage id="global.reference" />,
      render: (text, record) => {
        return (
          <Button type="link" onClick={() => onOpenModalInfo(record)}>
            {record.order_no}
          </Button>
        );
      },
    },
    {
      key: 'pay_status',
      dataIndex: 'pay_status',
      title: <IntlMessage id="global.status" />,
      render: (text, record) => {
        return (
          <Space direction="vertical">
            <Status status={record?.order_status?.toLowerCase()} type="order" />
            <Status status={record?.pay_status?.toLowerCase()} type="pay" />
          </Space>
        );
      },
    },
    {
      key: 'start',
      dataIndex: 'start',
      title: <IntlMessage id="global.travel" />,
      render: (text, record) => {
        return (
          <Space size={2} direction="vertical">
            <Text>
              {convertToAnyTimezone(record?.date).format('DD/MM/YYYY')}
            </Text>
            <Text>{record?.order_items?.[0]?.segment?.start_time}</Text>
          </Space>
        );
      },
    },
    {
      key: 'user_id',
      dataIndex: 'user_id',
      title: <IntlMessage id="global.customer" />,
      render: (text, record) => {
        return (
          record?.passengers?.[0]?.firstname +
          ' ' +
          record?.passengers?.[0]?.lastname
        );
      },
    },
    {
      key: 'pay_method',
      dataIndex: 'pay_method',
      title: <IntlMessage id="global.method" />,
      render: (text, record) => {
        return capitalizeFirstLetter(record?.pay_method || '');
      },
    },

    {
      key: 'from',
      dataIndex: 'from.title',
      title: <IntlMessage id="global.from" />,
      render: (text, record) => {
        return record?.route?.start_location?.title;
      },
    },

    {
      key: 'to',
      dataIndex: 'to.title',
      title: <IntlMessage id="global.to" />,
      render: (text, record) => {
        return record?.route?.end_location?.title;
      },
    },
    {
      key: 'total',
      dataIndex: 'total',
      title: <IntlMessage id="global.total" />,
      render: (text, record) => {
        return formatCurrency(Number(record.total));
      },
    },
    {
      key: 'created',
      dataIndex: 'created',
      title: <IntlMessage id="global.date" />,
      render: (text, record) => {
        return (
          <Space size={2} direction="vertical">
            <Text>
              {convertToAnyTimezone(record?.created_at).format('DD/MM/YYYY')}
            </Text>
            <Text>
              {convertToAnyTimezone(record?.created_at).format('HH:mm:ss')}
            </Text>
          </Space>
        );
      },
    },
  ];

  const onChangeBookingCreated = (e) => {
    onFilter(e.target.value, e.target.name, '');
  };

  return (
    <Card>
      <Space style={{ width: '100%' }} direction="vertical" size={4}>
        <Row className="page-title" justify={'space-between'}>
          <Col>
            {/* <PageTitle title={<IntlMessage id="global.orders" />} /> */}
            <Text style={{ fontSize: '20px' }} strong>
              <IntlMessage id="global.orders" />
            </Text>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
          <Col sm={{ span: 6 }} xs={{ span: 12 }}>
            <Search
              name="search"
              className="txtSearch"
              placeholder="Référence/Téléphone"
              allowClear
              onChange={(e) =>
                onFilter(e.target.value, e.target.name, 'search')
              }
              style={{ width: '100%' }}
            />
          </Col>
          {/* <Col>
            <Button
              type="primary"
              onClick={() => {
                setSearch((e) => !e);
              }}>
              Search
            </Button>
          </Col> */}
        </Row>
        <Divider style={{ margin: '0 0', color: 'gray', marginBottom: '16px' }}>
          Filter
        </Divider>
        <Row gutter={[8, 8]}>
          <Col sm={{ span: 6 }} xs={{ span: 8 }}>
            <Select
              // mode={item.type}
              showSearch
              placeholder={<IntlMessage id="placeholder.select_status_order" />}
              onChange={(value) => onFilter(value, 'order_status')}
              style={{ width: '100%' }}
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (typeof option.children !== 'string') {
                  if (option?.children?.props?.id) {
                    return (
                      intl
                        .formatMessage({ id: option?.children?.props?.id })
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  } else {
                    return (
                      option.value
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  }
                }
                return (
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input?.toLowerCase()) >= 0
                );
              }}
              defaultValue={item?.defaultValue}>
              {Object.values(OrderStatus).map((option, i) => {
                return (
                  <Select.Option
                    key={i}
                    value={option?.status ? option?.status.toUpperCase() : ''}>
                    {option?.title}
                  </Select.Option>
                );
              })}
            </Select>
          </Col>
          <Col sm={{ span: 6 }} xs={{ span: 8 }}>
            <Select
              // mode={item.type}
              showSearch
              placeholder={<IntlMessage id="global.select_pay_status" />}
              onChange={(value) => onFilter(value, 'pay_status')}
              style={{ width: '100%' }}
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (typeof option.children !== 'string') {
                  if (option?.children?.props?.id) {
                    return (
                      intl
                        .formatMessage({ id: option?.children?.props?.id })
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  } else {
                    return (
                      option.value
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  }
                }
                return (
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input?.toLowerCase()) >= 0
                );
              }}
              defaultValue={item?.defaultValue}>
              {Object.values(PayStatus).map((option, i) => {
                return (
                  <Select.Option
                    key={i}
                    value={option?.status ? option?.status.toUpperCase() : ''}>
                    {option?.title}
                  </Select.Option>
                );
              })}
            </Select>
          </Col>
          <Col sm={{ span: 6 }} xs={{ span: 8 }}>
            <Select
              // mode={item.type}
              showSearch
              placeholder={<IntlMessage id="global.select_pay_method" />}
              onChange={(value) => onFilter(value, 'pay_method')}
              style={{ width: '100%' }}
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (typeof option.children !== 'string') {
                  if (option?.children?.props?.id) {
                    return (
                      intl
                        .formatMessage({ id: option?.children?.props?.id })
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  } else {
                    return (
                      option.value
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  }
                }
                return (
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input?.toLowerCase()) >= 0
                );
              }}
              defaultValue={item?.defaultValue}>
              {Object.values(pay_method).map((option, i) => {
                return (
                  <Select.Option key={i} value={option ? option : ''}>
                    {option}
                  </Select.Option>
                );
              })}
            </Select>
          </Col>
          <Col>
            <Select
              showSearch
              style={{
                minWidth: 200,
              }}
              //onChange = {handleChangeCurrency}
              allowClear
              placeholder="Caissier"
              optionFilterProp="children"
              onChange={(value) => onFilter(value, 'created_by')}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }>
              {cashier.map((option, index) => {
                return (
                  <Select.Option
                    key={`${option.value}_${index}`}
                    value={option?.value}>
                    {option?.label}
                  </Select.Option>
                );
              })}
            </Select>
          </Col>
        </Row>
        <Row>
          <Form form={form_filter} onFinish={onSearchDate}>
            <Row justify={'start'}>
              <Col>
                <Radio.Group
                  name="date_type"
                  onChange={(e) => onFilter(e.target.value, e.target.name, '')}
                  defaultValue={dataDateType[0].value}>
                  <Flex vertical>
                    {dataDateType?.map((item, index) => {
                      return (
                        <Radio key={index} value={item?.value}>
                          {item?.label}
                        </Radio>
                      );
                    })}
                  </Flex>
                </Radio.Group>
              </Col>
              <Col>
                <Form.Item
                  name={'mode'}
                  initialValue={'date'}
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfeild" />,
                    },
                  ]}>
                  <Select
                    placeholder="Select mode"
                    onSelect={onChangeMode}
                    options={[
                      {
                        value: 'date',
                        label: <IntlMessage id="global.date" />,
                      },
                      {
                        value: 'month',
                        label: <IntlMessage id="global.month" />,
                      },
                      {
                        value: 'day',
                        label: <IntlMessage id="global.day" />,
                      },
                    ]}></Select>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name={isModeTravel ? 'from_date' : 'from_created_at'}
                  // initialValue={dayjs().startOf('M')}
                  dependencies={['mode', 'to_date']}
                  rules={[
                    {
                      required: false,
                      message: <IntlMessage id="global.requiredfeild" />,
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (getFieldValue('mode')) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error('Please select mode!!')
                        );
                      },
                    }),
                  ]}>
                  <DatePicker
                    placeholder={mode === 'month' ? 'Mois' : 'Date'}
                    format={mode === 'month' ? 'MM-YYYY' : 'DD-MM-YYYY'}
                    picker={mode}
                  />
                </Form.Item>
              </Col>
              {mode === 'date' && (
                <Col>
                  <Form.Item
                    name={isModeTravel ? 'to_date' : 'to_created_at'}
                    // initialValue={dayjs().endOf('M')}
                    dependencies={['mode', 'from_date']}
                    rules={[
                      {
                        required: false,
                        message: <IntlMessage id="global.requiredfeild" />,
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            (value && getFieldValue('from_date')) ||
                            !getFieldValue('from_date')
                          ) {
                            return Promise.resolve();
                          }

                          return Promise.reject(
                            new Error('Please select from date!!')
                          );
                        },
                      }),
                    ]}>
                    <DatePicker
                      placeholder="Date"
                      format={'DD-MM-YYYY'}
                      picker={mode}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Filtrer
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Row>
        {/* <FilterBar
          filter={filter}
          onFilter={onFilter}
          searchType={true}
          dataSearchType={[
            {
              value: 'order_number',
              label: 'Reference',
            },
            {
              value: 'telephone',
              label: 'Phone',
            },
          ]}
          data={[
            {
              name: 'order_status',
              data: Object.values(OrderStatus).map((item) => {
                return {
                  id: item?.status.toUpperCase(),
                  title: item?.status,
                };
              }),
              placeholder: <IntlMessage id="placeholder.select_status" />,
            },
            {
              name: 'pay_status',
              data: [
                {
                  id: PayStatus.pending.status,
                  title: PayStatus.pending.status,
                },
                { id: PayStatus.success.status, title: 'Paid' },
              ],
              placeholder: <IntlMessage id="global.select_pay_status" />,
            },
            {
              name: 'pay_method',
              data: Object.values(pay_method).map((item) => {
                return {
                  id: item,
                  title: item,
                };
              }),
              placeholder: <IntlMessage id="global.select_pay_method" />,
            },
          ]}
        >
          
        </FilterBar> */}
        <br />
        <Table
          dataSource={items}
          columns={columns}
          tableLayout="auto"
          loading={loading}
          bordered
          rowKey="id"
          scroll={{ x: 'max-content' }}
          size="small"
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            total: total,
            current: filter.page,
            pageSize: filter.limit,
          }}
          onChange={onChangeTable}
        />
      </Space>
      {openModalInfo && (
        <ModalInfoBooking
          open={openModalInfo}
          item={item}
          onClose={onCloseModalInfo}
        />
      )}
    </Card>
  );
};

export default Orders;
